// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"7b637725","837":"84a85c8f"}[chunkId] + ".chunk.css";
};